<template>
  <div class="trend">
    <div class="banner-top">
      <div class="banner-box"></div>
      <div class="banner-desc">把脉全球政经，预判大势拐点，寻找资产配置的核心密码</div>
    </div>
    <div class="trend-box">
      <el-row :gutter="20">
        <el-col :span="12" v-for="(item, i) in menuList" :key="i">
          <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="tooltip">
          <div class="grid-content bg-purple cursorPointer" @click="token && clickTrueView(i)">
            <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
          </div>
          </el-tooltip>
        </el-col>

      </el-row>

      <!--      首席观点-->
      <div class="list" v-show="currentIndex === 0">
<!--        <div class="zx-list">-->
<!--          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">-->
<!--            <el-tab-pane label="全部" name="first">-->
<!--              <div class="main-content">-->
<!--                <div class="left">-->
<!--                  <div class="list-box" v-for="(item,i) in itemViewList" :key="i">-->
<!--                    <div class="img-box">-->
<!--                      <img class="thumb-img" :src="item.img" alt="">-->
<!--                    </div>-->
<!--                    <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                      <div class="article_title">-->
<!--                        <div class="title">{{ item.title }}</div>-->
<!--                        <div class="list-content">{{ item.desc }}</div>-->
<!--                        <div class="list-bottom">-->
<!--                          {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="right">-->
<!--                  <div class="recommend">-->
<!--                    <div class="top">-->
<!--                      <div class="title">最新推荐</div>-->
<!--                    </div>-->
<!--                    <div class="recommend-list">-->
<!--                      <ul id="recommendList">-->
<!--                        <li v-for="(item, i) in itemZxList" :key="i">-->
<!--                          <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                            <img :src="item.img">-->
<!--                            <div class="recommend-title">{{ item.title }}</div>-->
<!--                            <div class="recommend-bottom">-->
<!--                              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="more">-->
<!--                <div class="cursorPointer">-->
<!--                  <div @click="getSxViewMore();getZxMore()">点击加载更多...</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="中国首席财经" name="second">-->
<!--              <div class="main-content">-->
<!--                <div class="left">-->
<!--                  <div class="list-box" v-for="(item, i) in itemCjList" :key="i">-->
<!--                    <div class="img-box">-->
<!--                      <img class="thumb-img" :src="item.img" alt="">-->
<!--                    </div>-->
<!--                    <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                      <div class="article_title">-->
<!--                        <div class="title">{{ item.title }}</div>-->
<!--                        <div class="list-content">{{ item.desc }}</div>-->
<!--                        <div class="list-bottom">-->
<!--                          {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="right">-->
<!--                  <div class="recommend">-->
<!--                    <div class="top">-->
<!--                      <div class="title">最新推荐</div>-->
<!--                    </div>-->
<!--                    <div class="recommend-list">-->
<!--                      <ul id="sx-recommendList">-->
<!--                        <li v-for="(item, i) in itemTjList" :key="i">-->
<!--                          <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                            <img :src="item.img">-->
<!--                            <div class="recommend-title">{{ item.title }}</div>-->
<!--                            <div class="recommend-bottom">-->
<!--                              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="more">-->
<!--                <div class="cursorPointer">-->
<!--                  <div @click="getCjMore();getCjZxMore()">点击加载更多...</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="首席证券内参" name="third">-->
<!--              <div class="main-content">-->
<!--                <div class="left">-->
<!--                  <div class="list-box" v-for="(item, i) in itemZqList" :key="i">-->
<!--                    <div class="img-box">-->
<!--                      <img class="thumb-img" :src="item.img" alt="">-->
<!--                    </div>-->
<!--                    <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                      <div class="article_title">-->
<!--                        <div class="title">{{ item.title }}</div>-->
<!--                        <div class="list-content">{{ item.desc }}</div>-->
<!--                        <div class="list-bottom">-->
<!--                          {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="right">-->
<!--                  <div class="recommend">-->
<!--                    <div class="top">-->
<!--                      <div class="title">最新推荐</div>-->
<!--                    </div>-->
<!--                    <div class="recommend-list">-->
<!--                      <ul id="zq-recommendList">-->
<!--                        <li v-for="(item, i) in itemZqTjList" :key="i">-->
<!--                          <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                            <img :src="item.img">-->
<!--                            <div class="recommend-title">{{ item.title }}</div>-->
<!--                            <div class="recommend-bottom">-->
<!--                              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="more">-->
<!--                <div class="cursorPointer">-->
<!--                  <div @click="getZqMore();getZqZxMore()">点击加载更多...</div>-->
<!--                </div>-->
<!--              </div>-->

<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="首席策略研判" name="fourth" style="display: none">-->
<!--              <div class="main-content">-->
<!--                <div class="left">-->
<!--                  <div class="list-box" v-for="(item, i) in itemYpList" :key="i">-->
<!--                    <div class="img-box">-->
<!--                      <img class="thumb-img" :src="item.img" alt="">-->
<!--                    </div>-->
<!--                    <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                      <div class="article_title">-->
<!--                        <div class="title">{{ item.title }}</div>-->
<!--                        <div class="list-content">{{ item.desc }}</div>-->
<!--                        <div class="list-bottom">-->
<!--                          {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="right">-->
<!--                  <div class="recommend">-->
<!--                    <div class="top">-->
<!--                      <div class="title">最新推荐</div>-->
<!--                    </div>-->
<!--                    <div class="recommend-list">-->
<!--                      <ul id="yp-recommendList">-->
<!--                        <li v-for="(item, i) in itemYpTjList" :key="i">-->
<!--                          <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                            <img :src="item.img">-->
<!--                            <div class="recommend-title">{{ item.title }}</div>-->
<!--                            <div class="recommend-bottom">-->
<!--                              {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </li>-->
<!--                      </ul>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="more">-->
<!--                <div class="cursorPointer">-->
<!--                  <div @click="getYpMore();getYpZxMore()">点击加载更多...</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="　" disabled></el-tab-pane>-->
<!--          </el-tabs>-->

          <div class="list-box" v-for="(item,i) in itemCjList" :key="i">
            <div class="img-box">
              <img class="thumb-img" :src="item.img" alt="">
            </div>
            <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
              <div class="article_title">
                <div class="title">{{ item.title }}</div>
                <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
              </div>
            </a>
          </div>
          <div class="more">
            <div class="cursorPointer">
              <div @click="getCjMore">点击加载更多...</div>
            </div>
          </div>



<!--        </div>-->
      </div>

      <!--      决策参考-->
      <div class="list" v-show="currentIndex === 1">
<!--        <div class="zx-list">-->

<!--            <el-tabs v-model="activeCkName" type="card" @tab-click="handleClick">-->
<!--              <el-tab-pane label="全部" name="five">-->
<!--                <div class="main-content">-->
<!--                  <div class="left">-->
<!--                    <div class="list-box" v-for="(item,i) in itemCkList" :key="i">-->
<!--                      <div class="img-box">-->
<!--                        <img class="thumb-img" :src="item.img" alt="">-->
<!--                      </div>-->
<!--                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                        <div class="article_title">-->
<!--                          <div class="title">{{ item.title }}</div>-->
<!--                          <div class="list-content">{{ item.desc }}</div>-->
<!--                          <div class="list-bottom">-->
<!--                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="right">-->
<!--                    <div class="recommend">-->
<!--                      <div class="top">-->
<!--                        <div class="title">最新推荐</div>-->
<!--                      </div>-->
<!--                      <div class="recommend-list">-->
<!--                        <ul id="ck-recommendList">-->
<!--                          <li v-for="(item, i) in itemAllTjList" :key="i">-->
<!--                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                              <img :src="item.img">-->
<!--                              <div class="recommend-title">{{ item.title }}</div>-->
<!--                              <div class="recommend-bottom">-->
<!--                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="more">-->
<!--                  <div class="cursorPointer">-->
<!--                    <div @click="getJcCkMore();getAllZxMore()">点击加载更多...</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-tab-pane>-->
<!--              <el-tab-pane label="高层决策内参" name="six">-->
<!--                <div class="main-content">-->
<!--                  <div class="left">-->
<!--                    <div class="list-box" v-for="(item, i) in itemGcJcList" :key="i">-->
<!--                      <div class="img-box">-->
<!--                        <img class="thumb-img" :src="item.img" alt="">-->
<!--                      </div>-->
<!--                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                        <div class="article_title">-->
<!--                          <div class="title">{{ item.title }}</div>-->
<!--                          <div class="list-content">{{ item.desc }}</div>-->
<!--                          <div class="list-bottom">-->
<!--                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="right">-->
<!--                    <div class="recommend">-->
<!--                      <div class="top">-->
<!--                        <div class="title">最新推荐</div>-->
<!--                      </div>-->
<!--                      <div class="recommend-list">-->
<!--                        <ul id="jc-recommendList">-->
<!--                          <li v-for="(item, i) in itemJcTjList" :key="i">-->
<!--                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                              <img :src="item.img">-->
<!--                              <div class="recommend-title">{{ item.title }}</div>-->
<!--                              <div class="recommend-bottom">-->
<!--                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="more">-->
<!--                  <div class="cursorPointer">-->
<!--                    <div @click="getGcMore();getGcZxMore()">点击加载更多...</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-tab-pane>-->
<!--              <el-tab-pane label="金融机构内参" name="seven">-->
<!--                <div class="main-content">-->
<!--                  <div class="left">-->
<!--                    <div class="list-box" v-for="(item, i) in itemJrJgList" :key="i">-->
<!--                      <div class="img-box">-->
<!--                        <img class="thumb-img" :src="item.img" alt="">-->
<!--                      </div>-->
<!--                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                        <div class="article_title">-->
<!--                          <div class="title">{{ item.title }}</div>-->
<!--                          <div class="list-content">{{ item.desc }}</div>-->
<!--                          <div class="list-bottom">-->
<!--                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="right">-->
<!--                    <div class="recommend">-->
<!--                      <div class="top">-->
<!--                        <div class="title">最新推荐</div>-->
<!--                      </div>-->
<!--                      <div class="recommend-list">-->
<!--                        <ul id="jr-recommendList">-->
<!--                          <li v-for="(item, i) in itemJrTjList" :key="i">-->
<!--                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                              <img :src="item.img">-->
<!--                              <div class="recommend-title">{{ item.title }}</div>-->
<!--                              <div class="recommend-bottom">-->
<!--                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="more">-->
<!--                  <div class="cursorPointer">-->
<!--                    <div @click="getJrMore();getJrZxMore()">点击加载更多...</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-tab-pane>-->
<!--              <el-tab-pane label="国际资讯参考" name="eight">-->
<!--                <div class="main-content">-->
<!--                  <div class="left">-->
<!--                    <div class="list-box" v-for="(item, i) in itemGjZxList" :key="i">-->
<!--                      <div class="img-box">-->
<!--                        <img class="thumb-img" :src="item.img" alt="">-->
<!--                      </div>-->
<!--                      <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                        <div class="article_title">-->
<!--                          <div class="title">{{ item.title }}</div>-->
<!--                          <div class="list-content">{{ item.desc }}</div>-->
<!--                          <div class="list-bottom">-->
<!--                            {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </a>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="right">-->
<!--                    <div class="recommend">-->
<!--                      <div class="top">-->
<!--                        <div class="title">最新推荐</div>-->
<!--                      </div>-->
<!--                      <div class="recommend-list">-->
<!--                        <ul id="gj-recommendList">-->
<!--                          <li v-for="(item, i) in itemGjTjList" :key="i">-->
<!--                            <a style="display: block;" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">-->
<!--                              <img :src="item.img">-->
<!--                              <div class="recommend-title">{{ item.title }}</div>-->
<!--                              <div class="recommend-bottom">-->
<!--                                {{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}-->
<!--                              </div>-->
<!--                            </a>-->
<!--                          </li>-->
<!--                        </ul>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="more">-->
<!--                  <div class="cursorPointer">-->
<!--                    <div @click="getGjMore();getGjZxMore()">点击加载更多...</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </el-tab-pane>-->
<!--              <el-tab-pane label="　" name="x" disabled></el-tab-pane>-->
<!--            </el-tabs>-->
<!--          </div>-->

        <div class="list-box" v-for="(item,i) in itemZqList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getZqMore">点击加载更多...</div>
          </div>
        </div>


        </div>

      <!--      大势-->
      <div class="list" v-show="currentIndex === ''">
        <div class="list-box" v-for="(item,i) in itemList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=trend'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
                <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getMore">点击加载更多...</div>
          </div>
        </div>
      </div>
    </div>

    <div class="back-top" @click="backTop" v-show="btnFlag">
      <img src="../assets/images/return_top.png" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import {CkAll, SxAll, ViewList, ZxList, CjList, ZqList, YpList, GcJcList, JrJgList, GjZxList, ZxTjList, ZxZqList, ZxYpList, ZxJcList, ZxJrList, ZxGjList, ZxAllList} from "@/api/news";

export default {
  data() {
    return {
      currentTab:'first',
      activeName: 'first',
      currentCkTab:'five',
      activeCkName: 'five',
      token: window.localStorage.getItem('token'),
      itemList: [],
      itemViewList: [],
      itemCjList: [],
      itemZqList: [],
      itemYpList: [],
      itemZxList: [],
      itemCkList: [],
      itemGcJcList: [],
      itemJrJgList: [],
      itemGjZxList: [],
      itemTjList: [],
      itemZqTjList: [],
      itemYpTjList: [],
      itemAllTjList: [],
      itemJcTjList: [],
      itemJrTjList: [],
      itemGjTjList: [],
      menuList:[
        {
          imgUrl: require('../assets/images/icon_每日A股2.png'),
          imgUrls: require('../assets/images/icon_每日A股1.png'),
          txt: '中国首席财经',
          desc: '市场核心矛盾的分析研判'
        },
        {
          imgUrl: require('../assets/images/icon_决策参考2.png'),
          imgUrls: require('../assets/images/icon_决策参考1.png'),
          txt: '首席证券内参',
          desc: '专业机构内参，仅供高层参考'
        },
      ],
      currentIndex:'',
      btnFlag: false,
      page: 1,
      pageTj:1,
      sxPage:1,
      pageTj1:1,
      sxPage1:1,
      pageTj2:1,
      sxPage2:1,
      pageTj3:1,
      sxPage3:1,
      pageCkTj:1,
      ckPage:1,
      pageCkTj1:1,
      ckPage1:1,
      pageCkTj2:1,
      ckPage2:1,
      pageCkTj3:1,
      ckPage3:1,
    };
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getAllList()
    this.getAllSxViewList()
    this.getCjList()
    this.getZxList()
    this.getCjZxList()
    this.getZqList()
    this.getZqZxList()
    this.getYpList()
    this.getYpZxList()
    this.getCkList()
    this.getGcJcList()
    this.getGjZxZxList()
    this.getJrJgList()
    this.getJrZxList()
    this.getGjZxList()
    this.getJcZxList()
    this.getAllZxList()
  },
  mounted() {
    this.toJump()
    this.toCkJump()
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const currentDs = this.currentTab;
        // console.log(currentDs);
        // if(currentDs ==='first' || currentDs ==='second' || currentDs === 'third' || currentDs === 'fourth'){
        if(currentDs ==='second'){
          this.currentIndex = 0
        }else if(currentDs === 'third'){
          this.currentIndex = 1
        }
      }
    },
    toCkJump(){
      if(this.$route.query.activeCkName!=null){
        this.activeCkName = this.$route.query.activeCkName;
        this.currentCkTab = this.$route.query.currentCkTab;
        const currentCk = this.currentCkTab;
        // console.log(currentCk);
        // console.log(currentCk);
        if(currentCk ==='five' || currentCk ==='six' || currentCk === 'seven' || currentCk === 'eight'){
          this.currentIndex = 1
        }
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event)
      const updateTime = {
        "中国首席财经": "(更新频率：每周一、三、五盘前)",
        "首席证券内参": "(更新频率：交易日盘前)",
        "首席策略研判": "(更新频率：交易日盘前)",
        "高层决策内参": "(更新频率：每周一盘前)",
        "金融机构内参": "(更新频率：每周一、三、五盘前)",
        "国际资讯参考": "(更新频率：每周一、三、五盘前)",
      };
      if (tab.name == 'second') {
        let txt = tab.label
        $("#tab-4").text(updateTime[txt]);
      } else if( tab.name == 'third' || tab.name == 'fourth' ) {
        let txt = tab.label
        $("#tab-4").text(updateTime[txt]);
      } else if(tab.name == 'six') {
        let txt = tab.label
        $("#tab-x").text(updateTime[txt]);
      }else if(tab.name == 'seven' || tab.name == 'eight') {
        let txt = tab.label
        $("#tab-x").text(updateTime[txt]);
      }else if (tab.name == 'first'){
        $("#tab-4").text('　');
      }else if (tab.name == 'five'){
        $("#tab-x").text('　');
      }
    },
    clickTrueView(index) {
      this.currentIndex = index
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    // 大势list
    getAllList() {
      SxAll({id: '1nhl6bdfari', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    // 首席观点全部list
    getAllSxViewList() {
      ViewList({id: '1tvzs6z6p76', page: this.sxPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemViewList = this.itemViewList.concat(response.data.data)
        }
      });
    },
    // 全部推荐
    getZxList() {
      ZxList({id:'2bwoal5oysw',limit: 3, page: this.pageTj}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemZxList = this.itemZxList.concat(response.data.data)
        }
      });
    },
    // 首席财经推荐
    getCjZxList() {
      ZxTjList({id:'2bwoal5oysw',limit: 3, page: this.pageTj1}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemTjList = this.itemTjList.concat(response.data.data)
        }
      });
    },
    // 证券内参推荐
    getZqZxList() {
      ZxZqList({id:'2bwoal5oysw',limit: 3, page: this.pageTj2}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemZqTjList = this.itemZqTjList.concat(response.data.data)
        }
      });
    },
    // 研判推荐
    getYpZxList() {
      ZxYpList({id:'2bwoal5oysw',limit: 3, page: this.pageTj3}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYpTjList = this.itemYpTjList.concat(response.data.data)
        }
      });
    },
    // 决策参考全部推荐
    getAllZxList() {
      ZxAllList({id:'2bwoal5oysw',limit: 3, page: this.pageCkTj}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemAllTjList = this.itemAllTjList.concat(response.data.data)
        }
      });
    },
    // 高层决策推荐
    getJcZxList() {
      ZxJcList({id:'2bwoal5oysw',limit: 3, page: this.pageCkTj1}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJcTjList = this.itemJcTjList.concat(response.data.data)
        }
      });
    },
    // 金融机构推荐
    getJrZxList() {
      ZxJrList({id:'2bwoal5oysw',limit: 3, page: this.pageCkTj2}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJrTjList = this.itemJrTjList.concat(response.data.data)
        }
      });
    },
    // 国际资讯推荐
    getGjZxZxList() {
      ZxGjList({id:'2bwoal5oysw',limit: 3, page: this.pageCkTj3}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemGjTjList = this.itemGjTjList.concat(response.data.data)
        }
      });
    },
    // 中国首席财经list
    getCjList() {
      CjList({id: '2q341gee8pa', page: this.sxPage1}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemCjList = this.itemCjList.concat(response.data.data)
        }
      });
    },
    // 首席证券内参list
    getZqList() {
      ZqList({id: '10qreys8fcl', page: this.sxPage2}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemZqList = this.itemZqList.concat(response.data.data)
        }
      });
    },
    // 首席策略研判list
    getYpList() {
      YpList({id: '2e67b4nohck', page: this.sxPage3}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemYpList = this.itemYpList.concat(response.data.data)
        }
      });
    },
    //决策参考全部List
    getCkList() {
      CkAll({id: 'cmb4i595v9', page: this.ckPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemCkList = this.itemCkList.concat(response.data.data)
        }
      });
    },
    //高层决策内参List
    getGcJcList() {
      GcJcList({id: 'xlbwzupf0f', page: this.ckPage1}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemGcJcList = this.itemGcJcList.concat(response.data.data)
        }
      });
    },
    //金融机构内参List
    getJrJgList() {
      JrJgList({id: 'y31yofr2ll', page: this.ckPage2}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemJrJgList = this.itemJrJgList.concat(response.data.data)
        }
      });
    },
    //国际资讯参考List
    getGjZxList() {
      GjZxList({id: '29jlo3z1kui', page: this.ckPage3}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemGjZxList = this.itemGjZxList.concat(response.data.data)
        }
      });
    },
    // 大势更多
    getMore() {
      this.page++;
      this.getAllList()
    },
    //首席观点更多
    getSxViewMore() {
      this.sxPage++;
      this.getAllSxViewList()
    },
    //决策参考更多
    getJcCkMore() {
      this.ckPage++;
      this.getCkList()
    },
    // 全部推荐更多
    getZxMore() {
      this.pageTj++;
      this.getZxList()
    },
    // 首席财经推荐更多
    getCjZxMore() {
      this.pageTj1++;
      this.getCjZxList()
    },
    // 证券内参推荐更多
    getZqZxMore() {
      this.pageTj2++;
      this.getZqZxList()
    },
    // 研判推荐更多
    getYpZxMore() {
      this.pageTj3++;
      this.getYpZxList()
    },
    // 决策参考全部推荐更多
    getAllZxMore() {
      this.pageCkTj++;
      this.getAllZxList()
    },
    //高层决策推荐更多
    getGcZxMore() {
      this.pageCkTj1++;
      this.getJcZxList()
    },
    //金融机构推荐更多
    getJrZxMore() {
      this.pageCkTj2++;
      this.getJrZxList()
    },
    //国际资讯推荐更多
    getGjZxMore() {
      this.pageCkTj3++;
      this.getGjZxZxList()
    },
    //首席财经更多
    getCjMore() {
      this.sxPage1++;
      this.getCjList()
    },
    //首席证券更多
    getZqMore() {
      this.sxPage2++;
      this.getZqList()
    },
    //首席研判更多
    getYpMore() {
      this.sxPage3++;
      this.getYpList()
    },
    //高层决策更多
    getGcMore() {
      this.ckPage1++;
      this.getGcJcList()
    },
    //金融机构更多
    getJrMore() {
      this.ckPage2++;
      this.getJrJgList()
    },
    //国际资讯更多
    getGjMore() {
      this.ckPage3++;
      this.getGjZxList()
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
>>>#tab-fourth{
  display: none;
}
.trend {
  background-color: #F5F7FA;
}

.trend-box {
  width: 1200px;
  margin: -30px auto 0;
}

.active{
  color: #ffe400;
}

.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}

.banner-box {
  width: 1200px;
  margin: 0 auto;
}

.main-content{
  display: flex;
  width: 1200px;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.zx-list {
  width: 1200px;
  margin-top: 10px;
  display: flex;
}

.zx-list .left {
  width: 900px;
  margin-right: 10px;
}

.zx-list .right {
  width: 300px;
  margin-top: -44px;
}

.zx-list .right .recommend .recommend-list:not(:first-child) {
  padding: 30px 0;
  background: #fff;
  margin-top: 14px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}

.zx-list .right .recommend .recommend-list ul {
  width: 260px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li:not(:last-child) {
  border-bottom: 1px solid #cdcdcd;
  margin-bottom: 30px;
}

.zx-list .right .recommend .recommend-list li img {
  width: 260px;
  height: 120px;
  margin: 0 auto;
}

.zx-list .right .recommend .recommend-list li .recommend-title {
  margin: 15px 0;
  font-size: 14px;
  color: #313131;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.zx-list .right .recommend .top .title {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #FFFFFF;
  background-image: linear-gradient(#0c255c, #040f27);
}

.zx-list .right .recommend .recommend-list li .recommend-bottom {
  font-size: 12px;
  color: #898989;
  margin-bottom: 23px;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

>>> .el-tabs__item {
  width: 160px;
  text-align: center;
  color: #313131;
  background-color: #FFFFFF;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
}

>>> .is-active {
  color: #FFFFFF;
  height: 30px;
  background-image: linear-gradient(#0c255c, #040f27);
}

>>> .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__item {
  border: 1px solid #E4E7ED;
  margin-right: 10px;
}

>>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

>>>#tab-4{
  border: none;
  background-color: transparent;
  text-align: right;
  font-size: 12px;
}

>>>#tab-x{
  border: none;
  background-color: transparent;
  text-align: right;
  font-size: 12px;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}

</style>



// WEBPACK FOOTER //
// src/components/Trend.vue